<list-creature-page [onlyMy]="false"></list-creature-page>